package ai.jessie.web.documents

// UC-020 B8: the list views of the BR-131 states. Inbox stays the default (UC-017 B6); an unknown
// route value falls back to it.
enum class DocumentFilter(val label: String, val icon: String) {
    INBOX("Inbox", "inbox"),
    REVIEW("Prüfung", "search"),
    ACCOUNTING("Buchhaltung", "calculator"),
    ARCHIVED("Archiv", "archive"),
    REJECTED("Abgelehnt", "times-circle");

    companion object {
        fun of(value: String?): DocumentFilter = entries.firstOrNull { it.name == value } ?: INBOX
    }
}
